import React from 'react';
import styled from 'styled-components';
import TrueImpactTextfield, {
  TrueImpactTextfieldProps,
} from './TrueImpactTextfield';
import { textSelectionNone } from '../base/TrueImpactText';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

type TrueImpactTextfieldWithIconProps = TrueImpactTextfieldProps & {
  sideText: string | JSX.Element;
  side: 'left' | 'right';
  innerBorder?: boolean;
  state?: 'success' | 'error';
  inputPadding?: string;
  sidePadding?: string;
  wrapperClassName?: string;
};

const StyledDiv = styled.div<{
  inputPadding: string;
  sidePadding: string;
  disabled?: boolean;
  innerBorder: boolean;
  state?: TrueImpactTextfieldWithIconProps['state'];
  side: TrueImpactTextfieldWithIconProps['side'];
}>`
  position: relative;
  input {
    padding-${({ side }) => side}: ${({ inputPadding }) => inputPadding};
    ${({ state }) =>
      state === 'success'
        ? `border-color: ${COLORS.success}; background-color: ${COLORS.successBackground};`
        : state === 'error'
        ? `border-color: ${COLORS.critical}; background-color: ${COLORS.criticalBackground};`
        : ''};
  }
  .textfield-within-icon {
    position: absolute;
    top: 0;
    ${({ disabled }) => (disabled ? 'cursor: not-allowed;' : '')}
    ${({ side }) => side}: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ innerBorder, side }) =>
      innerBorder
        ? `border-${side === 'left' ? 'right' : 'left'}: 1px solid ${
            COLORS.grayBase
          };`
        : ''}
    ${({ sidePadding }) =>
      `padding-left: ${sidePadding}; padding-right: ${sidePadding};`}
    ${textSelectionNone}
  }
`;

const TrueImpactTextfieldWithIcon: React.FC<TrueImpactTextfieldWithIconProps> = (
  props: TrueImpactTextfieldWithIconProps,
) => {
  const {
    side,
    sideText,
    inputPadding = SPACERS.large,
    sidePadding = SPACERS.tiny,
    innerBorder = true,
    state,
    wrapperClassName,
    ...rest
  } = props;
  return (
    <StyledDiv
      side={side}
      state={state}
      innerBorder={innerBorder}
      inputPadding={inputPadding}
      sidePadding={sidePadding}
      disabled={props.disabled}
      className={wrapperClassName}
    >
      <TrueImpactTextfield {...rest} />
      <div className="textfield-within-icon">{sideText}</div>
    </StyledDiv>
  );
};

export default TrueImpactTextfieldWithIcon;
